// extracted by mini-css-extract-plugin
export default {"featuresList":"FeaturesTextSection_featuresList__jdwp2","featureItem":"FeaturesTextSection_featureItem__AFDLU","featureKey":"FeaturesTextSection_featureKey__d3ql3"};